export async function loadCourse(courseKey) {
  if (!courseKey) return null;

  try {
    const [
      exercisesMod,
      glossaryMod,
      metadataMod,
      sharedMod,
      aboutMod,
      audiofilesMod,
      contextMod,
    ] = await Promise.all([
      import(`./courses/${courseKey}/exercises.js`).catch(() => null),
      import(`./courses/${courseKey}/glossary.js`).catch(() => null),
      import(`./courses/${courseKey}/metadata.js`).catch(() => null),
      import(`./courses/${courseKey}/shared.js`).catch(() => null),
      import(`./courses/${courseKey}/about.js`).catch(() => null),
      import(`./courses/${courseKey}/audiofiles.js`).catch(() => null),
      import(`./courses/${courseKey}/context.js`).catch(() => null),
    ]);

    const nothingLoaded =
      !exercisesMod &&
      !glossaryMod &&
      !metadataMod &&
      !sharedMod &&
      !aboutMod &&
      !audiofilesMod &&
      !contextMod;

    if (nothingLoaded) {
      console.warn(`[loadCourse] missing course "${courseKey}"`);
      return null;
    }

    const metadata =
      metadataMod?.default ??
      metadataMod?.METADATA ??
      {};

    return {
      exercises:
        exercisesMod?.default ??
        exercisesMod?.EXERCISES ??
        [],

      GlossaryPanel:
        glossaryMod?.default ??
        null,

      AboutPanel:
        aboutMod?.default ??
        null,

      metadata,

      shared:
        sharedMod?.default ??
        {},

      audioMeta:
        audiofilesMod?.default ??
        audiofilesMod?.INTONATION_AUDIO_META_EN ??
        audiofilesMod?.AUDIO_META ??
        null,

      context:
        contextMod?.context ??
        contextMod?.default ??
        [],

      help:
        metadata?.help ??
        { enabled: false, mode: "none" },

      ui:
        metadata?.ui ??
        { defaultMode: "audiobook", modes: ["audiobook"] },
    };
  } catch (err) {
    console.warn(`[loadCourse] missing course "${courseKey}"`, err);
    return null;
  }
}